"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCategoryTypeEnum = void 0;
var TransactionCategoryTypeEnum;
(function (TransactionCategoryTypeEnum) {
    TransactionCategoryTypeEnum["INFLOW"] = "INFLOW";
    TransactionCategoryTypeEnum["OUTFLOW"] = "OUTFLOW";
})(TransactionCategoryTypeEnum || (exports.TransactionCategoryTypeEnum = TransactionCategoryTypeEnum = {}));
